<template>
  <v-card flat class="filters-container">
    <!-- Barra de búsqueda -->
    <v-text-field
      v-model="searchQuery"
      prepend-inner-icon="mdi-magnify"
      placeholder="Buscar chat..."
      dense
      outlined
      hide-details
      class="search-field"
      clearable
      @input="handleSearch"
    ></v-text-field>

    <!-- Chips para filtros -->
    <v-chip-group
      v-model="selectedFilter"
      mandatory
      active-class="primary--text"
      class="mt-2"
    >
      <v-chip
        v-for="filter in filters"
        :key="filter.value"
        :value="filter.value"
        small
        @click="handleFilterChange(filter.value)"
      >
        {{ filter.label }}
        <v-badge
          v-if="filter.count"
          :content="filter.count"
          color="primary"
          inline
          class="ml-2"
        ></v-badge>
      </v-chip>
    </v-chip-group>
  </v-card>
</template>

<script>
export default {
  name: 'TwilioFilters',

  data: () => ({
    searchQuery: '',
    selectedFilter: 'all',
    filters: [
      { label: 'Todos', value: 'all', count: null },
      { label: 'No leídos', value: 'unread', count: 5 },
      { label: 'Archivados', value: 'archived', count: 2 },
      { label: 'Importantes', value: 'important', count: 3 },
    ]
  }),

  methods: {
    handleSearch(value) {
      this.$emit('search', value)
    },

    handleFilterChange(filter) {
      this.$emit('filter-change', filter)
    }
  }
}
</script>

<style scoped>
.filters-container {
  padding: 8px 16px;
}

.search-field {
  max-width: 100%;
}
</style>
